<template>
  <v-container>
    <v-btn color="info" class="white--text" @click="print" ref="button">
      <v-icon>printer</v-icon>
      Print
    </v-btn>
    <div ref="book" class="book">
      
      <!-- Title Page -->
      <div class="title page" style="page-break-inside: avoid;">
        <div class="box">
          <h1>Fuel Book</h1>
          Version 2.0.0
        </div>
      </div>
      <div v-for="day in asyncComputedBook" v-bind:key="day.id" class="page">
        <div class="box">
          <h1>{{ day.title }}</h1>
          {{ day.subtitle }}
        </div>
        <h3>Morning</h3>
        <br>
        <!-- Morning Stack -->
        <table>
          <tr>
            <td v-if="day.aaron.morningStack"><h4>{{ day.aaron.morningStack.name }}</h4></td>
            <td v-else></td>
            <td v-if="day.ronan.morningStack"><h4>{{ day.ronan.morningStack.name }}</h4></td>
            <td v-else></td>
          </tr>
          <tr>
            <td v-if="day.aaron.morningStack">  
              <div v-for="ingredient in day.aaron.morningStack.ingredients" v-bind:key="ingredient.id">
                {{ ingredient.portion }} @ {{ ingredient.serving }}{{ ingredient.unit }} x {{ ingredient.name }}<br>
              </div>
            </td>
            <td v-else></td>
            <td v-if="day.ronan.morningStack">
              <div v-for="ingredient in day.ronan.morningStack.ingredients" v-bind:key="ingredient.id">
                {{ ingredient.portion }} @ {{ ingredient.serving }}{{ ingredient.unit }} x {{ ingredient.name }}<br>
              </div>
            </td>
            <td v-else></td>
          </tr>
        </table>
        <br>
        <!-- Breakfast -->
        <table>
          <tr>
            <td v-if="day.aaron.breakfast"><h4>{{ day.aaron.breakfast.name }}</h4></td>
            <td v-else></td>
            <td v-if="day.ronan.breakfast"><h4>{{ day.ronan.breakfast.name }}</h4></td>
            <td v-else></td>
          </tr>
          <tr>
            <td v-if="day.aaron.breakfast">  
              <div v-for="ingredient in day.aaron.breakfast.ingredients" v-bind:key="ingredient.id">
                {{ ingredient.portion }} @ {{ ingredient.serving }}{{ ingredient.unit }} x {{ ingredient.name }}<br>
              </div>
            </td>
            <td v-else></td>
            <td v-if="day.ronan.breakfast">
              <div v-for="ingredient in day.ronan.breakfast.ingredients" v-bind:key="ingredient.id">
                {{ ingredient.portion }} @ {{ ingredient.serving }}{{ ingredient.unit }} x {{ ingredient.name }}<br>
              </div>
            </td>
            <td v-else></td>
          </tr>
        </table>
        <br>
        <!-- Morning Snack -->
        <table>
          <tr>
            <td v-if="day.aaron.morningSnack"><h4>{{ day.aaron.morningSnack.name }}</h4></td>
            <td v-else></td>
            <td v-if="day.ronan.morningSnack"><h4>{{ day.ronan.morningSnack.name }}</h4></td>
            <td v-else></td>
          </tr>
          <tr>
            <td v-if="day.aaron.morningSnack">  
              <div v-for="ingredient in day.aaron.morningSnack.ingredients" v-bind:key="ingredient.id">
                {{ ingredient.portion }} @ {{ ingredient.serving }}{{ ingredient.unit }} x {{ ingredient.name }}<br>
              </div>
            </td>
            <td v-else></td>
            <td v-if="day.ronan.morningSnack">
              <div v-for="ingredient in day.ronan.morningSnack.ingredients" v-bind:key="ingredient.id">
                {{ ingredient.portion }} @ {{ ingredient.serving }}{{ ingredient.unit }} x {{ ingredient.name }}<br>
              </div>
            </td>
            <td v-else></td>
          </tr>
        </table>
        <h3>Afternoon</h3>
        <br>
        <!-- Afternoon Stack -->
        <table>
          <tr>
            <td v-if="day.aaron.afternoonStack"><h4>{{ day.aaron.afternoonStack.name }}</h4></td>
            <td v-else></td>
            <td v-if="day.ronan.afternoonStack"><h4>{{ day.ronan.afternoonStack.name }}</h4></td>
            <td v-else></td>
          </tr>
          <tr>
            <td v-if="day.aaron.afternoonStack">  
              <div v-for="ingredient in day.aaron.afternoonStack.ingredients" v-bind:key="ingredient.id">
                {{ ingredient.portion }} @ {{ ingredient.serving }}{{ ingredient.unit }} x {{ ingredient.name }}<br>
              </div>
            </td>
            <td v-else></td>
            <td v-if="day.ronan.afternoonStack">
              <div v-for="ingredient in day.ronan.afternoonStack.ingredients" v-bind:key="ingredient.id">
                {{ ingredient.portion }} @ {{ ingredient.serving }}{{ ingredient.unit }} x {{ ingredient.name }}<br>
              </div>
            </td>
            <td v-else></td>
          </tr>
        </table>
        <br>
        <!-- Lunch -->
        <table>
          <tr>
            <td v-if="day.aaron.lunch"><h4>{{ day.aaron.lunch.name }}</h4></td>
            <td v-else></td>
            <td v-if="day.ronan.lunch"><h4>{{ day.ronan.lunch.name }}</h4></td>
            <td v-else></td>
          </tr>
          <tr>
            <td v-if="day.aaron.lunch">  
              <div v-for="ingredient in day.aaron.lunch.ingredients" v-bind:key="ingredient.id">
                {{ ingredient.portion }} @ {{ ingredient.serving }}{{ ingredient.unit }} x {{ ingredient.name }}<br>
              </div>
            </td>
            <td v-else></td>
            <td v-if="day.ronan.lunch">
              <div v-for="ingredient in day.ronan.lunch.ingredients" v-bind:key="ingredient.id">
                {{ ingredient.portion }} @ {{ ingredient.serving }}{{ ingredient.unit }} x {{ ingredient.name }}<br>
              </div>
            </td>
            <td v-else></td>
          </tr>
        </table>
        <br>
        <!-- Afternoon Snack -->
        <table>
          <tr>
            <td v-if="day.aaron.afternoonSnack"><h4>{{ day.aaron.afternoonSnack.name }}</h4></td>
            <td v-else></td>
            <td v-if="day.ronan.afternoonSnack"><h4>{{ day.ronan.afternoonSnack.name }}</h4></td>
            <td v-else></td>
          </tr>
          <tr>
            <td v-if="day.aaron.afternoonSnack">  
              <div v-for="ingredient in day.aaron.afternoonSnack.ingredients" v-bind:key="ingredient.id">
                {{ ingredient.portion }} @ {{ ingredient.serving }}{{ ingredient.unit }} x {{ ingredient.name }}<br>
              </div>
            </td>
            <td v-else></td>
            <td v-if="day.ronan.afternoonSnack">
              <div v-for="ingredient in day.ronan.afternoonSnack.ingredients" v-bind:key="ingredient.id">
                {{ ingredient.portion }} @ {{ ingredient.serving }}{{ ingredient.unit }} x {{ ingredient.name }}<br>
              </div>
            </td>
            <td v-else></td>
          </tr>
        </table>
        <h3>Evening</h3>
        <br>
        <!-- Evening Stack -->
        <table>
          <tr>
            <td v-if="day.aaron.eveningStack"><h4>{{ day.aaron.eveningStack.name }}</h4></td>
            <td v-else></td>
            <td v-if="day.ronan.eveningStack"><h4>{{ day.ronan.eveningStack.name }}</h4></td>
            <td v-else></td>
          </tr>
          <tr>
            <td v-if="day.aaron.eveningStack">  
              <div v-for="ingredient in day.aaron.eveningStack.ingredients" v-bind:key="ingredient.id">
                {{ ingredient.portion }} @ {{ ingredient.serving }}{{ ingredient.unit }} x {{ ingredient.name }}<br>
              </div>
            </td>
            <td v-else></td>
            <td v-if="day.ronan.eveningStack">
              <div v-for="ingredient in day.ronan.eveningStack.ingredients" v-bind:key="ingredient.id">
                {{ ingredient.portion }} @ {{ ingredient.serving }}{{ ingredient.unit }} x {{ ingredient.name }}<br>
              </div>
            </td>
            <td v-else></td>
          </tr>
        </table>
        <br>
        <!-- Dinner -->
        <table>
          <tr>
            <td v-if="day.aaron.dinner"><h4>{{ day.aaron.dinner.name }}</h4></td>
            <td v-else></td>
            <td v-if="day.ronan.dinner"><h4>{{ day.ronan.dinner.name }}</h4></td>
            <td v-else></td>
          </tr>
          <tr>
            <td v-if="day.aaron.dinner">  
              <div v-for="ingredient in day.aaron.dinner.ingredients" v-bind:key="ingredient.id">
                {{ ingredient.portion }} @ {{ ingredient.serving }}{{ ingredient.unit }} x {{ ingredient.name }}<br>
              </div>
            </td>
            <td v-else></td>
            <td v-if="day.ronan.dinner">
              <div v-for="ingredient in day.ronan.dinner.ingredients" v-bind:key="ingredient.id">
                {{ ingredient.portion }} @ {{ ingredient.serving }}{{ ingredient.unit }} x {{ ingredient.name }}<br>
              </div>
            </td>
            <td v-else></td>
          </tr>
        </table>
        <br>
        <!-- Evening Snack -->
        <table>
          <tr>
            <td v-if="day.aaron.eveningSnack"><h4>{{ day.aaron.eveningSnack.name }}</h4></td>
            <td v-else></td>
            <td v-if="day.ronan.eveningSnack"><h4>{{ day.ronan.eveningSnack.name }}</h4></td>
            <td v-else></td>
          </tr>
          <tr>
            <td v-if="day.aaron.eveningSnack">  
              <div v-for="ingredient in day.aaron.eveningSnack.ingredients" v-bind:key="ingredient.id">
                {{ ingredient.portion }} @ {{ ingredient.serving }}{{ ingredient.unit }} x {{ ingredient.name }}<br>
              </div>
            </td>
            <td v-else></td>
            <td v-if="day.ronan.eveningSnack">
              <div v-for="ingredient in day.ronan.eveningSnack.ingredients" v-bind:key="ingredient.id">
                {{ ingredient.portion }} @ {{ ingredient.serving }}{{ ingredient.unit }} x {{ ingredient.name }}<br>
              </div>
            </td>
            <td v-else></td>
          </tr>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import db from '@/firebase/firestore'
export default {
  name: "Book",
  data() {
    return {
      book: [],
      computedBook: [],
      meals: [],
      food: [],
    }
  },
  created() {
    // Load Meals
    db.collection('meals').get().then((snapshot) => {
      snapshot.forEach( doc => {
        let meal = doc.data()
        this.meals[doc.id] = meal
      })
    })
    // Load Food
    db.collection('food').get().then((snapshot) => {
      snapshot.forEach( doc => {
        let food = doc.data()
        this.food[doc.id] = food
      })
    })
    // Load Plan
    let planRef = db.collection('plan')
    planRef.get().then((snapshot) => {
      snapshot.forEach( doc => {
        let day = doc.data()
        this.book.push({
          id: day.day,
          title: day.name,
          subtitle: 'Week ' + day.week,
          aaron: day.aaron,
          ronan: day.ronan
        })
      })
      console.log('Book', this.book)
      this.loading = false
    })
  },
  computed: {
    orderedBook: function() {
      return _.orderBy(this.book,'id')
    }
  },
  asyncComputed: {
    asyncComputedBook() {
      this.computedBook = []
      let orderedBook = _.orderBy(this.book,'id')
      return new Promise( (resolve, reject) => {
        orderedBook.forEach( page => {
          let newPage = {
            title: page.title,
            subtitle: page.subtitle
          }
          // Get the meals for this page
          if( !newPage.aaron ) newPage.aaron = []
          if( !newPage.ronan ) newPage.ronan = []
          // ---------- Morning Stack
          if( page.aaron.morningStack.id ) {
            newPage.aaron.morningStack = {
              name: page.aaron.morningStack.name,
              components: this.meals[page.aaron.morningStack.id].components
            }
            newPage.aaron.morningStack.ingredients = []
            newPage.aaron.morningStack.components.forEach( ingredient => {
              let food = this.food[ingredient.id]
              food.portion = ingredient.portion * page.aaron.morningStack.portion
              newPage.aaron.morningStack.ingredients.push(food)
            })
            delete(newPage.aaron.morningStack.components)
          }
          //
          if( page.ronan.morningStack.id ) {
            newPage.ronan.morningStack = {
              name: page.ronan.morningStack.name,
              components: this.meals[page.ronan.morningStack.id].components
            }
            newPage.ronan.morningStack.ingredients = []
            newPage.ronan.morningStack.components.forEach( ingredient => {
              let food = this.food[ingredient.id]
              food.portion = ingredient.portion * page.ronan.morningStack.portion
              newPage.ronan.morningStack.ingredients.push(food)
            })
            delete(newPage.ronan.morningStack.components)
          }
          // ---------- Breakfast
          if( page.aaron.breakfast.id ) {
            newPage.aaron.breakfast = {
              name: page.aaron.breakfast.name,
              components: this.meals[page.aaron.breakfast.id].components
            }
            newPage.aaron.breakfast.ingredients = []
            newPage.aaron.breakfast.components.forEach( ingredient => {
              let food = this.food[ingredient.id]
              food.portion = ingredient.portion * page.aaron.breakfast.portion
              newPage.aaron.breakfast.ingredients.push(food)
            })
            delete(newPage.aaron.breakfast.components)
          }
          //
          if( page.ronan.breakfast.id ) {
            newPage.ronan.breakfast = {
              name: page.ronan.breakfast.name,
              components: this.meals[page.ronan.breakfast.id].components
            }
            newPage.ronan.breakfast.ingredients = []
            newPage.ronan.breakfast.components.forEach( ingredient => {
              let food = this.food[ingredient.id]
              food.portion = ingredient.portion * page.ronan.breakfast.portion
              newPage.ronan.breakfast.ingredients.push(food)
            })
            delete(newPage.ronan.breakfast.components)
          }
          // ---------- Morning Snack
          if( page.aaron.morningSnack.id ) {
            newPage.aaron.morningSnack = {
              name: page.aaron.morningSnack.name,
              components: this.meals[page.aaron.morningSnack.id].components
            }
            newPage.aaron.morningSnack.ingredients = []
            newPage.aaron.morningSnack.components.forEach( ingredient => {
              let food = this.food[ingredient.id]
              food.portion = ingredient.portion * page.aaron.morningSnack.portion
              newPage.aaron.morningSnack.ingredients.push(food)
            })
            delete(newPage.aaron.morningSnack.components)
          }
          //
          if( page.ronan.morningSnack.id ) {
            newPage.ronan.morningSnack = {
              name: page.ronan.morningSnack.name,
              components: this.meals[page.ronan.morningSnack.id].components
            }
            newPage.ronan.morningSnack.ingredients = []
            newPage.ronan.morningSnack.components.forEach( ingredient => {
              let food = this.food[ingredient.id]
              food.portion = ingredient.portion * page.ronan.morningSnack.portion
              newPage.ronan.morningSnack.ingredients.push(food)
            })
            delete(newPage.ronan.morningSnack.components)
          }
          // ---------- Afternoon Stack
          if( page.aaron.afternoonStack.id ) {
            newPage.aaron.afternoonStack = {
              name: page.aaron.afternoonStack.name,
              components: this.meals[page.aaron.afternoonStack.id].components
            }
            newPage.aaron.afternoonStack.ingredients = []
            newPage.aaron.afternoonStack.components.forEach( ingredient => {
              let food = this.food[ingredient.id]
              food.portion = ingredient.portion * page.aaron.afternoonStack.portion
              newPage.aaron.afternoonStack.ingredients.push(food)
            })
            delete(newPage.aaron.afternoonStack.components)
          }
          //
          if( page.ronan.afternoonStack.id ) {
            newPage.ronan.afternoonStack = {
              name: page.ronan.afternoonStack.name,
              components: this.meals[page.ronan.afternoonStack.id].components
            }
            newPage.ronan.afternoonStack.ingredients = []
            newPage.ronan.afternoonStack.components.forEach( ingredient => {
              let food = this.food[ingredient.id]
              food.portion = ingredient.portion * page.ronan.afternoonStack.portion
              newPage.ronan.afternoonStack.ingredients.push(food)
            })
            delete(newPage.ronan.afternoonStack.components)
          }
          // ---------- Lunch
          if( page.aaron.lunch.id ) {
            newPage.aaron.lunch = {
              name: page.aaron.lunch.name,
              components: this.meals[page.aaron.lunch.id].components
            }
            newPage.aaron.lunch.ingredients = []
            newPage.aaron.lunch.components.forEach( ingredient => {
              let food = this.food[ingredient.id]
              food.portion = ingredient.portion * page.aaron.lunch.portion
              newPage.aaron.lunch.ingredients.push(food)
            })
            delete(newPage.aaron.lunch.components)
          }
          //
          if( page.ronan.lunch.id ) {
            newPage.ronan.lunch = {
              name: page.ronan.lunch.name,
              components: this.meals[page.ronan.lunch.id].components
            }
            newPage.ronan.lunch.ingredients = []
            newPage.ronan.lunch.components.forEach( ingredient => {
              let food = this.food[ingredient.id]
              food.portion = ingredient.portion * page.ronan.lunch.portion
              newPage.ronan.lunch.ingredients.push(food)
            })
            delete(newPage.ronan.lunch.components)
          }
          // ---------- Afternoon Snack
          if( page.aaron.afternoonSnack.id ) {
            newPage.aaron.afternoonSnack = {
              name: page.aaron.afternoonSnack.name,
              components: this.meals[page.aaron.afternoonSnack.id].components
            }
            newPage.aaron.afternoonSnack.ingredients = []
            newPage.aaron.afternoonSnack.components.forEach( ingredient => {
              let food = this.food[ingredient.id]
              food.portion = ingredient.portion * page.aaron.afternoonSnack.portion
              newPage.aaron.afternoonSnack.ingredients.push(food)
            })
            delete(newPage.aaron.afternoonSnack.components)
          }
          //
          if( page.ronan.afternoonSnack.id ) {
            newPage.ronan.afternoonSnack = {
              name: page.ronan.afternoonSnack.name,
              components: this.meals[page.ronan.afternoonSnack.id].components
            }
            newPage.ronan.afternoonSnack.ingredients = []
            newPage.ronan.afternoonSnack.components.forEach( ingredient => {
              let food = this.food[ingredient.id]
              food.portion = ingredient.portion * page.ronan.afternoonSnack.portion
              newPage.ronan.afternoonSnack.ingredients.push(food)
            })
            delete(newPage.ronan.afternoonSnack.components)
          }
          // ---------- Evening Stack
          if( page.aaron.eveningStack.id ) {
            newPage.aaron.eveningStack = {
              name: page.aaron.eveningStack.name,
              components: this.meals[page.aaron.eveningStack.id].components
            }
            newPage.aaron.eveningStack.ingredients = []
            newPage.aaron.eveningStack.components.forEach( ingredient => {
              let food = this.food[ingredient.id]
              food.portion = ingredient.portion * page.aaron.eveningStack.portion
              newPage.aaron.eveningStack.ingredients.push(food)
            })
            delete(newPage.aaron.eveningStack.components)
          }
          //
          if( page.ronan.eveningStack.id ) {
            newPage.ronan.eveningStack = {
              name: page.ronan.eveningStack.name,
              components: this.meals[page.ronan.eveningStack.id].components
            }
            newPage.ronan.eveningStack.ingredients = []
            newPage.ronan.eveningStack.components.forEach( ingredient => {
              let food = this.food[ingredient.id]
              food.portion = ingredient.portion * page.ronan.eveningStack.portion
              newPage.ronan.eveningStack.ingredients.push(food)
            })
            delete(newPage.ronan.eveningStack.components)
          }
          // ---------- Dinner
          if( page.aaron.dinner.id ) {
            newPage.aaron.dinner = {
              name: page.aaron.dinner.name,
              components: this.meals[page.aaron.dinner.id].components
            }
            newPage.aaron.dinner.ingredients = []
            newPage.aaron.dinner.components.forEach( ingredient => {
              let food = this.food[ingredient.id]
              food.portion = ingredient.portion * page.aaron.dinner.portion
              newPage.aaron.dinner.ingredients.push(food)
            })
            delete(newPage.aaron.dinner.components)
          }
          //
          if( page.ronan.dinner.id ) {
            newPage.ronan.dinner = {
              name: page.ronan.dinner.name,
              components: this.meals[page.ronan.dinner.id].components
            }
            newPage.ronan.dinner.ingredients = []
            newPage.ronan.dinner.components.forEach( ingredient => {
              let food = this.food[ingredient.id]
              food.portion = ingredient.portion * page.ronan.dinner.portion
              newPage.ronan.dinner.ingredients.push(food)
            })
            delete(newPage.ronan.dinner.components)
          }
          // ---------- Evening Snack
          if( page.aaron.eveningSnack.id ) {
            newPage.aaron.eveningSnack = {
              name: page.aaron.eveningSnack.name,
              components: this.meals[page.aaron.eveningSnack.id].components
            }
            newPage.aaron.eveningSnack.ingredients = []
            newPage.aaron.eveningSnack.components.forEach( ingredient => {
              let food = this.food[ingredient.id]
              food.portion = ingredient.portion * page.aaron.eveningSnack.portion
              newPage.aaron.eveningSnack.ingredients.push(food)
            })
            delete(newPage.aaron.eveningSnack.components)
          }
          //
          if( page.ronan.eveningSnack.id ) {
            newPage.ronan.eveningSnack = {
              name: page.ronan.eveningSnack.name,
              components: this.meals[page.ronan.eveningSnack.id].components
            }
            newPage.ronan.eveningSnack.ingredients = []
            newPage.ronan.eveningSnack.components.forEach( ingredient => {
              let food = this.food[ingredient.id]
              food.portion = ingredient.portion * page.ronan.eveningSnack.portion
              newPage.ronan.eveningSnack.ingredients.push(food)
            })
            delete(newPage.ronan.eveningSnack.components)
          }
          // Add the new page
          this.computedBook.push(newPage)
        })
        resolve(this.computedBook)
      })
    }
  },
  methods: {
    print() {
      console.log('PRINT!')
      console.log(this.$refs['book'])
      console.log(this.$refs)
      document.body.innerHTML = this.$refs['book'].innerHTML
      console.log(this.$refs['body'])
      window.print();
    }
  }
}
</script>

<style scoped>
  .book {
    font-family: 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  }
  .page {
    page-break-after: always;
    height: 100%;
    font-family: 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  }
  .page .box {
    border: 1px solid black;
    padding: 20px;
    text-align: center;
  }
  .title.page {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 300px;
  }
  .title.page .box {
    border: 1px solid black;
    padding: 40px 100px;
    text-align: center;
  }
  td {
    vertical-align: top;
    width: 50%;
  }
  h3 {
    page-break-after: avoid;
  }
</style>
